import React from "react";

import {withApollo} from "react-apollo";

import SweetAlert from "react-bootstrap-sweetalert";

import withStyles from "material-ui/styles/withStyles";
import ErrorIcon from "@material-ui/icons/Error";
import DoneIcon from "@material-ui/icons/Done";
import Divider from '@material-ui/core/Divider';

import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import Button from "components/CustomButtons/Button.jsx";

import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

import {client, subClient} from "client";
import { callCheckSub } from "../graph";


class SingleLineCallFormServerCheck extends React.Component{
    constructor(props) {
        super(props);

        this.inlineInterval = null;

        this.state = {
            timer: 100,
            inLineDone: 1,
            statusHeader: "Checking server...",
            showReport: false
        };

        this.callCheckSubClient = null;
    }

    componentDidMount() {
        this.startCounter();
    }

    componentWillUnmount() {
        if (this.callCheckSubClient) {
            this.callCheckSubClient.unsubscribe();
            this.callCheckSubClient = null;
        }
    }

    callFailed() {
        const inLineDone = this.state.inLineDone;

        this.setState({
            inLineDone: inLineDone === 1 ? 2 : inLineDone,
        });

        clearInterval(this.inlineInterval);

        if (this.callCheckSubClient) {
            this.callCheckSubClient.unsubscribe();
            this.callCheckSubClient = null;
        }

        this.props.sendReportOpen("fail");
        this.props.serverCheckClose();
    }

    checkAsteriskChannel() {
        this.inlineInterval = setInterval(() => {
            let t = this.state.timer;

            t--;

            this.setState({timer: t});
        }, 1000);

        this.callCheckSubClient = client.subscribe({
            query: callCheckSub, // Subscription gql
            variables: {pin: this.props.pin, pid: this.props.pid}
        }).subscribe(
            response => {
                const data = JSON.parse(response.data.callCheckSub.jsonObject);

                if (data.asterisk_call_ended)
                    this.callFailed();

                if (data.members === 1) {
                    this.setState({
                        inLineDone: 3,
                    });
                }
                else if (data.members === 2) {
                    this.setState({
                        inLineDone: 3,
                        showReport: true
                    });

                    clearInterval(this.inlineInterval);

                    if (this.callCheckSubClient) {
                        this.callCheckSubClient.unsubscribe();
                        this.callCheckSubClient = null;
                    }

                    this.props.clearData();
                }

                if (this.state.timer <= 0) {
                    const inLineDone = this.state.inLineDone;

                    this.setState({
                        inLineDone: inLineDone === 1 ? 2 : inLineDone,
                    });

                    clearInterval(this.inlineInterval);

                    if (this.state.inLineDone == 2) {
                        this.props.sendReportOpen("fail");
                        this.props.serverCheckClose();
                    }

                    if (this.callCheckSubClient) {
                        this.callCheckSubClient.unsubscribe();
                        this.callCheckSubClient = null;
                    }
                }
            },
            error => {
                this.setState({
                    inLineDone: 2,
                });
            }
        );
    }

    startCounter() {
        this.checkAsteriskChannel();
    }

    onDoneBtnClick() {
        this.props.serverCheckClose();
    }

    onReportBtnClick() {
        this.props.sendReportOpen("success");
        this.props.serverCheckClose();
    }

    render() {
        const { timer,
            inLineDone,
            statusHeader,
            showReport } = this.state;

        let inlineStatus = null;
        let doneBtn = null;
        let reportContainer = null;

        if (inLineDone === 3)
            inlineStatus = (
                <i>
                    <DoneIcon /> Success...
                </i>
            );
        else if (inLineDone === 2)
            inlineStatus = (
                <i>
                    <ErrorIcon /> Failed...
                </i>
            );
        else
            inlineStatus = "Checking...";

        if (inLineDone !== 1) {
            doneBtn = (
                <Button variant="raised" onClick={this.onDoneBtnClick.bind(this)} color="rose" style={{'margin': '40px 0 0'}}>
                    Done
                </Button>
            );
        }

        if (showReport) {
            reportContainer = (
                <ItemGrid xs={3} sm={12}>
                    <Divider style={{'marginTop': '30px'}}/>
                    <GridContainer direction="row" style={{'padding': '20px 0 0'}}>
                        <ItemGrid sm={4}>
                            Do you wish to report something?
                        </ItemGrid>
                        <ItemGrid sm={5}>
                            <Button variant="raised" color='warning'
                                    style={{'float': 'left'}}
                                    onClick={this.onReportBtnClick.bind(this)}>Send Report</Button>
                        </ItemGrid>
                    </GridContainer>
                </ItemGrid>
            );
        }


        return (
            <SweetAlert
                title={statusHeader}
                onConfirm={() => this.props.onCallFormServerClose()}
                showConfirm={false}
                allowOutsideClick={false}
                allowEscapeKey={false}
                closeOnConfirm={false}
                closeOnCancel={false}
            >
                <GridContainer md={12} xs={12} sm={3}>
                    <ItemGrid xs={12} sm={12} md={12} >
                        <GridContainer direction="row">
                            <ItemGrid sm={12} xs={12} >
                                {timer}
                            </ItemGrid>
                        </GridContainer>
                    </ItemGrid>
                    <ItemGrid xs={12} sm={12} md={12} >
                        <GridContainer direction="row">
                            <ItemGrid sm={6} xs={6}  md={6}>
                                Inline:
                            </ItemGrid>
                            <ItemGrid sm={6} xs={6}  md={6}>
                                {inlineStatus}
                            </ItemGrid>
                        </GridContainer>
                    </ItemGrid>
                    <ItemGrid xs={12} sm={12} md={12} >
                        {doneBtn}
                    </ItemGrid>

                    {reportContainer}
                </GridContainer>
            </SweetAlert>
        );
    }
}

export default withStyles(sweetAlertStyle)(withApollo(SingleLineCallFormServerCheck));



// WEBPACK FOOTER //
// ./src/views/callform/components/SingleLineCallFormServerCheck.js